import {StyleSheet} from 'react-native';

const styles = StyleSheet.create({
  // **Shared Styles for Tag Views**

  tagSection: {
    display: 'flex',
    backgroundColor: '#262B2F',
    marginHorizontal: 'auto',
    width: '100%',
    borderRadius: 10
  },
  tagHeader: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: 3,
    backgroundColor: '#1B1D1F',
    marginTop: '5%'
  },
  tagHeaderText: {
    marginLeft: '5%',
    color: 'white'
  },
  searchContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginHorizontal: 'auto',
    paddingHorizontal: '2%',
    width: '94%',
    marginTop: '3%'
  },
  searchInput: {
    backgroundColor: 'white',
    borderRadius: 10,
    padding: 8,
    width: '90%'
  },
  icon: {
    fontSize: 25,
    color: '#fff',
    marginRight: '5%'
  },
  addIcon: {
    fontSize: 15,
    color: '#fff',
    marginRight: '5%'
  },
  tagListContainer: {
    marginTop: '2%',
    marginLeft: '5%',
    marginBottom: '2%',
    height: '20vh'
  },

  // **Shared Styles for Tag Items**

  tagContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginVertical: 5
  },
  tagWrapper: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%'
  },
  selectedTagWrapper: {
    width: '90%',
    padding: 5,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: '#808080'
  },
  tagText: {
    color: 'white',
    fontFamily: 'Poppins_600SemiBold',
    fontSize: 16,
    maxWidth: '80%'
  },
  cancelIcon: {
    fontSize: 15,
    color: 'gray'
  },

  // **Unique Styles for OrderTagsView**

  divider: {
    width: '96%',
    backgroundColor: '#ffffff',
    height: 1,
    alignSelf: 'center',
    marginVertical: 10,
    marginLeft: '-18px'
  },
  addNewTagContainer: {
    alignSelf: 'center',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row'
  },

  // **Unique Styles for OrderTags**

  colorBar: {
    width: 5,
    height: 20,
    borderRadius: 5,
    marginLeft: 10
  },

  overlay: {
    flex: 1,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    justifyContent: 'center',
    alignItems: 'center'
  },
  modalContent: {
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    padding: 0.5,
    borderRadius: 10,
    alignItems: 'center',
    maxWidth: '90%',
    maxHeight: '90%'
  },
  container: {
    width: 'fitContent',
    padding: 10,
    borderRadius: 5,
    alignSelf: 'flex-start',
    minWidth: 600
  },
  subContainer: {
    display: 'flex',
    flexDirection: 'column',
    padding: '5%',
    justifyContent: 'center'
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: 20,
    position: 'relative'
  },
  title: {
    color: '#fff',
    fontSize: 20,
    fontWeight: 'bold',
    textAlign: 'center'
  },
  tooltipButton: {
    position: 'absolute',
    right: 0,
    top: 0,
    padding: 5,
    zIndex: 100
  },
  infoIcon: {
    fontSize: 20,
    color: '#fff',
    cursor: 'pointer'
  },
  tooltipModalOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'transparent',
    zIndex: 1000
  },
  tooltipContainer: {
    borderRadius: 5,
    alignSelf: 'flex-start',
    zIndex: 99,
    elevation: 5
  },
  tooltipText: {
    color: '#000000',
    fontSize: 12,
    lineHeight: 18
  },
  tooltipTextBold: {
    fontWeight: 'bold'
  },
  tooltipArrow: {
    position: 'absolute',
    width: 0,
    height: 0,
    borderLeftWidth: 10,
    borderLeftColor: 'transparent',
    borderRightWidth: 10,
    borderRightColor: 'transparent',
    borderBottomWidth: 10,
    borderBottomColor: '#8a9daf'
  },
  loadingContainer: {
    padding: 40,
    alignItems: 'center'
  },
  loadingText: {
    color: '#fff',
    marginTop: 10,
    fontSize: 14
  },
  tableContainer: {
    marginTop: 20,
    borderRadius: 4,
    overflow: 'hidden'
  },
  tableHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#323943',
    borderBottomWidth: 1,
    borderBottomColor: '#4a5568'
  },
  tableHeaderCell: {
    flex: 1,
    paddingVertical: 10,
    paddingHorizontal: 15,
    alignItems: 'center',
    justifyContent: 'center'
  },
  tableHeaderDivider: {
    width: 0
  },
  tableHeaderText: {
    color: '#fff',
    fontSize: 14,
    fontWeight: '600',
    textAlign: 'center'
  },
  tableRow: {
    flexDirection: 'row',
    alignItems: 'stretch',
    borderBottomWidth: 1,
    borderBottomColor: '#4a5568',
    textAlign: 'center',
    textTransform: 'capitalize'
  },
  tableCell: {
    flex: 1,
    paddingVertical: 8,
    paddingHorizontal: 15,
    justifyContent: 'center',
    alignSelf: 'stretch',
    borderWidth: 0,
    borderTopWidth: 0,
    borderBottomWidth: 0,
    borderLeftWidth: 0,
    borderRightWidth: 0
  },
  zoneName: {
    color: '#fff',
    fontSize: 14,
    borderWidth: 0,
    margin: 0,
    paddingTop: 0,
    paddingBottom: 0
  },
  accessButton: {
    borderRadius: 24,
    minWidth: 110,
    alignSelf: 'center',
    overflow: 'hidden'
  },
  accessButtonGradient: {
    paddingVertical: 6,
    paddingHorizontal: 6,
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 24
  },
  accessButtonText: {
    fontSize: 14,
    fontWeight: '600',
    color: '#000'
  },
  saveButton: {
    borderWidth: 2,
    shadowColor: '#E853FA',
    shadowOffset: {width: 0, height: 0.5},
    shadowRadius: 8,
    marginLeft: 'auto',
    marginRight: 'auto',
    paddingVertical: 5,
    paddingHorizontal: 7
  },
  errorText: {
    color: 'red',
    marginTop: 10,
    textAlign: 'center'
  }
});

export default styles;
